import { FC } from 'react';
import { Size } from '../../enums';
import css from './style.module.css';
import { clsx } from '@team/clsx';

type Props = {
  size: Size;
};

export const Entry: FC<Props> = ({ size }) => {
  switch (size) {
    case Size.SMALL:
    default:
      return <Small />;
    case Size.MEDIUM:
      return <Medium />;
    case Size.LARGE:
      return <Large />;
  }
};

const Large: FC = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="matrix(-0.7071067811865475,-0.7071067811865476,0.7071067811865476,-0.7071067811865475,9.2715,37.5564)"
      className={clsx(css.stick, css.stick1)}
    >
      <path
        d="M2,0v0c1.10457,0 2,0.89543 2,2v10c0,1.10457 -0.89543,2 -2,2v0c-1.10457,0 -2,-0.89543 -2,-2v-10c0,-1.10457 0.89543,-2 2,-2z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(1,0,0,1,20,29)"
      className={clsx(css.stick, css.stick2)}
    >
      <path
        d="M2,0v0c1.10457,0 2,0.89543 2,2v9c0,1.10457 -0.89543,2 -2,2v0c-1.10457,0 -2,-0.89543 -2,-2v-9c0,-1.10457 0.89543,-2 2,-2z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(0.7071067811865476,-0.7071067811865475,0.7071067811865475,0.7071067811865476,24.8291,27.6569)"
      className={clsx(css.stick, css.stick3)}
    >
      <path
        d="M2,0v0c1.10457,0 2,0.89543 2,2v10c0,1.10457 -0.89543,2 -2,2v0c-1.10457,0 -2,-0.89543 -2,-2v-10c0,-1.10457 0.89543,-2 2,-2z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,29,24)"
      className={clsx(css.stick, css.stick4)}
    >
      <path
        d="M2,0v0c1.10457,0 2,0.89543 2,2v9c0,1.10457 -0.89543,2 -2,2v0c-1.10457,0 -2,-0.89543 -2,-2v-9c0,-1.10457 0.89543,-2 2,-2z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(-0.7071067811865475,-0.7071067811865476,0.7071067811865476,-0.7071067811865475,27.6592,19.1716)"
      className={clsx(css.stick, css.stick5)}
    >
      <path
        d="M2,0v0c1.10457,0 2,0.89543 2,2v10c0,1.10457 -0.89543,2 -2,2v0c-1.10457,0 -2,-0.89543 -2,-2v-10c0,-1.10457 0.89543,-2 2,-2z"
        fill="currentColor"
      />
    </g>
    <g transform="matrix(1,0,0,1,20,2)" className={clsx(css.stick, css.stick6)}>
      <path
        d="M2,0v0c1.10457,0 2,0.89543 2,2v9c0,1.10457 -0.89543,2 -2,2v0c-1.10457,0 -2,-0.89543 -2,-2v-9c0,-1.10457 0.89543,-2 2,-2z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(0.7071067811865476,-0.7071067811865475,0.7071067811865475,0.7071067811865476,6.4473,9.2721)"
      className={clsx(css.stick, css.stick7)}
    >
      <path
        d="M2,0v0c1.10457,0 2,0.89543 2,2v10c0,1.10457 -0.89543,2 -2,2v0c-1.10457,0 -2,-0.89543 -2,-2v-10c0,-1.10457 0.89543,-2 2,-2z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,2,24)"
      className={clsx(css.stick, css.stick8)}
    >
      <path
        d="M2,0v0c1.10457,0 2,0.89543 2,2v9c0,1.10457 -0.89543,2 -2,2v0c-1.10457,0 -2,-0.89543 -2,-2v-9c0,-1.10457 0.89543,-2 2,-2z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const Medium: FC = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="matrix(-0.7071067811865475,-0.7071067811865476,0.7071067811865476,-0.7071067811865475,6.7429,27.3137)"
      className={clsx(css.stick, css.stick1)}
    >
      <path
        d="M1.5,0v0c0.82843,0 1.5,0.67157 1.5,1.5v7.1818c0,0.82843 -0.67157,1.5 -1.5,1.5v0c-0.82843,0 -1.5,-0.67157 -1.5,-1.5v-7.1818c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(1,0,0,1,14.5454,21.0909)"
      className={clsx(css.stick, css.stick2)}
    >
      <path
        d="M1.5,0v0c0.82843,0 1.5,0.67157 1.5,1.5v6.4545c0,0.82843 -0.67157,1.5 -1.5,1.5v0c-0.82843,0 -1.5,-0.67157 -1.5,-1.5v-6.4545c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(0.7071067811865476,-0.7071067811865475,0.7071067811865475,0.7071067811865476,18.0575,20.1141)"
      className={clsx(css.stick, css.stick3)}
    >
      <path
        d="M1.5,0v0c0.82843,0 1.5,0.67157 1.5,1.5v7.1818c0,0.82843 -0.67157,1.5 -1.5,1.5v0c-0.82843,0 -1.5,-0.67157 -1.5,-1.5v-7.1818c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,21.0909,17.4545)"
      className={clsx(css.stick, css.stick4)}
    >
      <path
        d="M1.5,0v0c0.82843,0 1.5,0.67157 1.5,1.5v6.4545c0,0.82843 -0.67157,1.5 -1.5,1.5v0c-0.82843,0 -1.5,-0.67157 -1.5,-1.5v-6.4545c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(-0.7071067811865475,-0.7071067811865476,0.7071067811865476,-0.7071067811865475,20.1157,13.943)"
      className={clsx(css.stick, css.stick5)}
    >
      <path
        d="M1.5,0v0c0.82843,0 1.5,0.67157 1.5,1.5v7.1818c0,0.82843 -0.67157,1.5 -1.5,1.5v0c-0.82843,0 -1.5,-0.67157 -1.5,-1.5v-7.1818c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(1,0,0,1,14.5454,1.4545)"
      className={clsx(css.stick, css.stick6)}
    >
      <path
        d="M1.5,0v0c0.82843,0 1.5,0.67157 1.5,1.5v6.4545c0,0.82843 -0.67157,1.5 -1.5,1.5v0c-0.82843,0 -1.5,-0.67157 -1.5,-1.5v-6.4545c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(0.7071067811865476,-0.7071067811865475,0.7071067811865475,0.7071067811865476,4.6889,6.7433)"
      className={clsx(css.stick, css.stick7)}
    >
      <path
        d="M1.5,0v0c0.82843,0 1.5,0.67157 1.5,1.5v7.1818c0,0.82843 -0.67157,1.5 -1.5,1.5v0c-0.82843,0 -1.5,-0.67157 -1.5,-1.5v-7.1818c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,1.4545,17.4545)"
      className={clsx(css.stick, css.stick8)}
    >
      <path
        d="M1.5,0v0c0.82843,0 1.5,0.67157 1.5,1.5v6.4545c0,0.82843 -0.67157,1.5 -1.5,1.5v0c-0.82843,0 -1.5,-0.67157 -1.5,-1.5v-6.4545c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const Small: FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="matrix(-0.7071067811865475,-0.7071067811865476,0.7071067811865476,-0.7071067811865475,5.64,19.78)"
      className={clsx(css.stick, css.stick1)}
    >
      <path
        d="M1,0v0c0.55228,0 1,0.44772 1,1v5c0,0.55228 -0.44772,1 -1,1v0c-0.55228,0 -1,-0.44772 -1,-1v-5c0,-0.55228 0.44772,-1 1,-1z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(1,0,0,1,11,15)"
      className={clsx(css.stick, css.stick2)}
    >
      <path
        d="M1,0v0c0.55228,0 1,0.44772 1,1v5c0,0.55228 -0.44772,1 -1,1v0c-0.55228,0 -1,-0.44772 -1,-1v-5c0,-0.55228 0.44772,-1 1,-1z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(0.7071067811865476,-0.7071067811865475,0.7071067811865475,0.7071067811865476,13.41,14.83)"
      className={clsx(css.stick, css.stick3)}
    >
      <path
        d="M1,0v0c0.55228,0 1,0.44772 1,1v5c0,0.55228 -0.44772,1 -1,1v0c-0.55228,0 -1,-0.44772 -1,-1v-5c0,-0.55228 0.44772,-1 1,-1z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,15,13)"
      className={clsx(css.stick, css.stick4)}
    >
      <path
        d="M1,0v0c0.55228,0 1,0.44772 1,1v5c0,0.55228 -0.44772,1 -1,1v0c-0.55228,0 -1,-0.44772 -1,-1v-5c0,-0.55228 0.44772,-1 1,-1z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(1,0,0,1,13.41,4.22)"
      className={clsx(css.stick, css.stick5)}
    >
      <path
        d="M2.0341,6.01101c-0.46533,0.46533 -1.21977,0.46533 -1.6851,0c-0.46533,-0.46533 -0.46533,-1.21977 0,-1.6851l3.97691,-3.97691c0.46533,-0.46533 1.21977,-0.46533 1.6851,0c0.46533,0.46533 0.46533,1.21977 0,1.6851z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(1,0,0,1,11,1.9998)"
      className={clsx(css.stick, css.stick6)}
    >
      <path
        d="M1,0v0c0.55228,0 1,0.44772 1,1v5c0,0.55228 -0.44772,1 -1,1v0c-0.55228,0 -1,-0.44772 -1,-1v-5c0,-0.55228 0.44772,-1 1,-1z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(0.7071067811865476,-0.7071067811865475,0.7071067811865475,0.7071067811865476,4.22,5.64)"
      className={clsx(css.stick, css.stick7)}
    >
      <path
        d="M1,0v0c0.55228,0 1,0.44772 1,1v5c0,0.55228 -0.44772,1 -1,1v0c-0.55228,0 -1,-0.44772 -1,-1v-5c0,-0.55228 0.44772,-1 1,-1z"
        fill="currentColor"
      />
    </g>
    <g
      transform="matrix(6.123233995736766e-17,-1,1,6.123233995736766e-17,2.0003,13)"
      className={clsx(css.stick, css.stick8)}
    >
      <path
        d="M1,0v0c0.55228,0 1,0.44772 1,1v5c0,0.55228 -0.44772,1 -1,1v0c-0.55228,0 -1,-0.44772 -1,-1v-5c0,-0.55228 0.44772,-1 1,-1z"
        fill="currentColor"
      />
    </g>
  </svg>
);
